<template>
  <div class="order-course">
    <Form v-if="showTop" :model="searchCondition" :label-width="70" inline>
      <FormItem label="退款状态" v-if="searchCondition.order_type == 8">
        <Select
          v-model="searchCondition.order_mix_status"
          placeholder="请选择"
          style="width: 200px"
        >
          <Option
            v-for="item in refundOrderStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </Option>
        </Select>
      </FormItem>
      <FormItem label="订单状态" v-else>
        <EnumSelect
          class="com-width"
          type="GroupOrderStatus"
          selector="select"
          v-model="searchCondition.order_mix_status"
          :except="['2']"
        ></EnumSelect>
      </FormItem>
      <!-- <FormItem label="发货状态" v-if="searchCondition.order_type==4">
        <EnumSelect
          v-model="searchCondition.ship_status"
          class="com-width"
          type="ShipStatus"
          selector="select"
        ></EnumSelect>
      </FormItem> -->
      <FormItem label="支付类型">
        <Select v-model="searchCondition.pay_type" class="com-width" clearable>
          <Option v-for="item in payType" :value="item.key" :key="item.key">{{
            item.value
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="下单时间" v-if="searchCondition.order_type != 8">
        <Date-picker
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          @on-change="onDateRange"
          style="width: 280px"
          :editable="false"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Date-picker>
      </FormItem>
      <FormItem label="订单编号">
        <Input
          v-model="searchCondition.order_number"
          placeholder="请输入订单编号关键字"
          class="com-width"
          clearable
          @keydown.native.prevent.enter="onSearch"
        />
      </FormItem>
    </Form>
    <Form v-if="showTop" :model="searchCondition" :label-width="70" inline>
      <FormItem label="讲师名称" v-if="$route.name == 'OrderOne'">
        <Input
          v-model="searchCondition.teacher_name"
          placeholder="请输入讲师名称关键字"
          class="com-width"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="商品名称" v-else>
        <Input
          v-model="searchCondition.shop_name"
          placeholder="请输入商品名称关键字"
          class="com-width"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="手机号">
        <Input
          v-model="searchCondition.mobile"
          placeholder="请输入买家手机号"
          class="com-width"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="更新时间" v-if="searchCondition.order_type != 8">
        <Date-picker
          ref="formUpdateDate"
          type="datetimerange"
          placeholder="开始时间 — 结束时间"
          @on-change="onUpdateDateRange"
          style="width: 280px"
          :editable="false"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Date-picker>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div
      v-if="showTop && searchCondition.order_type != 8"
      style="position: relative"
    >
      <Button type="primary" @click="onExport('all')" class="btn-margin-right"
        >批量导出</Button
      >
      <Button
        type="primary"
        @click="onShip"
        class="btn-margin-right"
        v-if="searchCondition.order_type == 4"
        >批量发货</Button
      >
      <Button type="primary" @click="onWatch" class="btn-margin-right"
        >查看报表</Button
      >
      <Checkbox
        v-if="showOnlyRefund"
        v-model="onlyRefund"
        @on-change="onOnlyRefundChange"
        style="position: relative; top: 10px"
        >只看待退款</Checkbox
      >
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/order/index"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="order_id"
        method="post"
      >
        <template slot-scope="{ row }" slot="action">
          <div class="table-btn-box">
            <Button type="text" size="small" @click="onDetail(row)"
              >订单详情</Button
            >
            <Button type="text" size="small" @click="onShowRemarkModal(row)"
              >备注</Button
            >
            <Button
              type="text"
              size="small"
              @click="onDelivery(row)"
              v-if="
                searchCondition.order_type == 4 &&
                row.ship_status == 1 &&
                row.pay_status == 2
              "
              >发货</Button
            >
            <Button
              type="text"
              size="small"
              :to="{
                name: 'OrderBook',
                query: { order_number: row.order_number },
              }"
              v-if="
                searchCondition.order_type == 2 &&
                row.book_order_item_count > 0 &&
                row.pay_status == 2 &&
                row.ship_status == 1
              "
              >发货</Button
            >

            <div
              v-if="
                searchCondition.order_type != 1 &&
                searchCondition.order_type != 3
              "
            >
              <Button
                type="text"
                size="small"
                @click="onChangePrice(row)"
                v-if="row.order_status == 1 && row.pay_status == 1"
                >改价</Button
              >
              <!-- <Button type="text" size="small" @click="onRefund(row)" v-if="row.pay_status==2">退款</Button> -->
              <Button
                type="text"
                size="small"
                @click="onRefund(row)"
                v-if="row.pay_status == 3"
                class="refunding"
                >处理退款</Button
              >
              <div v-if="row.pay_status == 6" class="refund-fail">
                <Tooltip
                  transfer
                  theme="light"
                  placement="left"
                  :max-width="300"
                >
                  退款失败
                  <Icon type="ios-help-circle-outline" size="15" />
                  <div slot="content">退款失败原因：{{ row.refund_error }}</div>
                </Tooltip>
                <Button
                  type="text"
                  size="small"
                  @click="onRefund(row)"
                  class="refunding"
                  >处理退款</Button
                >
              </div>
              <div v-if="row.pay_status == 5" class="refund-success">
                <Tooltip
                  transfer
                  theme="light"
                  placement="left"
                  :max-width="300"
                >
                  退款成功
                  <Icon type="ios-help-circle-outline" size="15" />
                  <div slot="content">
                    <p>退款金额：{{ row.refund_price }}</p>
                    <p>备注：{{ row.refund_remark }}</p>
                  </div>
                </Tooltip>
              </div>
              <div
                v-if="row.pay_status == 2 && row.refund_status == 3"
                class="refund-success"
              >
                <Tooltip
                  transfer
                  theme="light"
                  placement="left"
                  :max-width="300"
                >
                  退款已拒绝
                  <Icon type="ios-help-circle-outline" size="15" />
                  <div slot="content">
                    <p>时间：{{ row.refund_refuse_time }}</p>
                    <p>备注：{{ row.refund_remark }}</p>
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </template>
      </Grid>
    </div>
    <Modal class="modal" v-model="modal.show" :title="modal.title">
      <div v-show="modal.type == 'detail'">
        <Form :label-width="120">
          <FormItem label="订单编号：">{{ modal.data.order_number }}</FormItem>
          <FormItem label="买家：">{{ modal.data.nickname }}</FormItem>
          <FormItem label="买家手机号：">{{ modal.data.mobile }}</FormItem>
          <FormItem label="老师名称：" v-if="$route.name == 'OrderOne'">{{
            modal.data.shop_name
          }}</FormItem>
          <FormItem label="商品名称：" v-else>{{
            modal.data.shop_name
          }}</FormItem>
          <FormItem label="下单时间：">{{ modal.data.created_at }}</FormItem>
          <FormItem label="支付类型：">{{ modal.data.pay_type_name }}</FormItem>
          <FormItem label="订单状态：">{{
            modal.data.order_status_name
          }}</FormItem>
          <!-- 课程显示QQ和用户备注，图书显示用户备注 -->
          <FormItem v-if="modal.data.shop_type < 11" label="qq号：">{{
            modal.data.qq
          }}</FormItem>
          <FormItem
            v-if="modal.data.shop_type < 11 || modal.data.shop_type == 12"
            label="用户备注："
            >{{ modal.data.user_remark }}</FormItem
          >
          <FormItem label="管理员备注：">{{ modal.data.remark }}</FormItem>

          <!-- 赠送课程 -->
          <div
            v-if="modal.data.gift_integral > 0 && modal.data.child.length > 0"
          >
            <Divider />
            <div class="title">赠送信息</div>

            <FormItem v-if="modal.data.gift_integral > 0" label="赠送积分：">{{
              modal.data.gift_integral
            }}</FormItem>
            <FormItem
              :label="giftType[item.type] + '：'"
              v-if="giftType[item.type]"
              v-for="item in modal.data.child"
              >{{ item.gifts_name }}</FormItem
            >
          </div>
          <!-- 赠送课程 -->
          <div v-if="searchCondition.order_type == 4">
            <Divider />
            <div class="title">收货信息</div>
            <FormItem label="发货状态：">{{
              modal.data.ship_status_name
            }}</FormItem>
            <FormItem label="收货地址：">{{
              modal.data.province_name +
              modal.data.city_name +
              modal.data.district_name +
              modal.data.address
            }}</FormItem>
            <FormItem label="收货人：">{{ modal.data.consignee }}</FormItem>
            <FormItem label="收货人手机号：">{{
              modal.data.consignee_mobile
            }}</FormItem>
          </div>
        </Form>
        <Divider />

        <Form :label-width="120" v-if="modal.data.logistics_number">
          <div class="title">物流信息</div>
          <FormItem label="快递名称：">{{
            modal.data.logistics_name
          }}</FormItem>
          <FormItem label="物流单号：">{{
            modal.data.logistics_number
          }}</FormItem>
          <FormItem label="配送时间：">{{
            new Date(modal.data.logistics_created * 1000).format(
              "yyyy/MM/dd hh:mm:ss"
            )
          }}</FormItem>
        </Form>

        <Form :label-width="420">
          <FormItem label="商品原价：">
            <img :src="modal.data.price_ico" style="width: 8px" />
            {{ modal.data.original_price }}
          </FormItem>
          <FormItem label="优惠券：">
            <img :src="modal.data.price_ico" style="width: 8px" />
            {{ modal.data.coupon_discount }}
          </FormItem>
          <FormItem label="订单金额：">
            <img :src="modal.data.price_ico" style="width: 8px" />
            {{ modal.data.order_price }}
          </FormItem>
        </Form>
      </div>
      <div v-show="modal.type == 'change'">
        <Form
          ref="modalForm"
          :model="modal.form"
          :rules="modal.rules"
          :label-width="120"
        >
          <FormItem label="订单编号：">{{ modal.data.order_number }}</FormItem>
          <FormItem label="订单金额：">{{ modal.data.order_price }}</FormItem>
          <FormItem label="修改订单金额为：" prop="adjustment_price">
            <InputNumber
              v-model="modal.form.adjustment_price"
              style="width: 150px; margin-right: 15px"
            ></InputNumber>
          </FormItem>
        </Form>
      </div>
      <div v-show="modal.type == 'refund'">
        <Form
          ref="modalForm"
          :model="modal.form"
          :rules="modal.rules"
          :label-width="90"
        >
          <FormItem label="订单编号：">{{ modal.data.order_number }}</FormItem>
          <FormItem label="订单金额：">{{ modal.data.order_price }}</FormItem>
          <FormItem label="退款意见：">
            <RadioGroup
              v-model="modal.form.type"
              @on-change="onRefundTypeChange"
            >
              <Radio label="2">拒绝</Radio>
              <Radio label="1">同意</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="退款金额：">
            <InputNumber
              v-model="modal.form.refund_price"
              style="width: 150px; margin-right: 15px"
            ></InputNumber>
          </FormItem>
          <FormItem label="备注信息：" prop="remark">
            <Input
              v-model="modal.form.remark"
              type="textarea"
              :rows="4"
              :placeholder="'请输入备注信息'"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer" style="text-align: center">
        <Button
          type="primary"
          @click="onModalOk"
          size="large"
          style="width: 100px"
          >{{ modal.btnLabel }}</Button
        >
      </div>
    </Modal>
    <ExportsModal
      :title="exportModalTitle"
      :type="3"
      :params="searchCondition"
      v-model="showExportModal"
      @onSuccess="onWatch"
    ></ExportsModal>
    <Modal class="modal" v-model="showDeliveryModal" title="填写发货单">
      <Form
        ref="deliveryForm"
        :model="deliveryForm"
        :rules="deliveryRules"
        :label-width="120"
      >
        <FormItem label="订单编号">{{ deliveryRow.order_number }}</FormItem>
        <Divider />
        <div class="title">备注信息</div>
        <FormItem label="用户备注：">{{
          deliveryRow.user_remark ? deliveryRow.user_remark : "--"
        }}</FormItem>
        <FormItem label="管理员备注：">{{
          deliveryRow.remark ? deliveryRow.remark : "--"
        }}</FormItem>
        <Divider />
        <div class="title">物流信息</div>
        <FormItem label="物流公司" prop="logistics_name">
          <Select v-model="deliveryForm.logistics_name">
            <Option
              v-for="item in shippers"
              :label="item"
              :value="item"
              :key="item"
            ></Option>
          </Select>
        </FormItem>
        <FormItem label="物流单号" prop="logistics_code">
          <Input
            v-model="deliveryForm.logistics_code"
            type="text"
            placeholder="请输入物流单号"
            :maxlength="50"
          ></Input>
        </FormItem>
        <FormItem label="物流费用" prop="logistics_fee">
          <InputNumber
            v-model="deliveryForm.logistics_fee"
            placeholder="请输入物流费用"
          ></InputNumber>
        </FormItem>
        <FormItem label="发货说明" prop="logistics_code">
          <Input
            v-model="deliveryForm.remark"
            type="textarea"
            placeholder="请输入发货说明"
            :rows="3"
            :maxlength="500"
          ></Input>
        </FormItem>
        <Divider />
        <div class="title">收货人信息</div>
        <FormItem label="收货地址：">{{
          deliveryRow.province_name +
          deliveryRow.city_name +
          deliveryRow.district_name +
          deliveryRow.address
        }}</FormItem>
        <FormItem label="收货人：">{{ deliveryRow.consignee }}</FormItem>
        <FormItem label="收货人手机号：">{{
          deliveryRow.consignee_mobile
        }}</FormItem>
      </Form>
      <template v-slot:footer>
        <Button type="default" @click="showDeliveryModal = false">取消</Button>
        <Button type="primary" @click="confirmDelivery">确认</Button>
      </template>
    </Modal>

    <Modal class="modal" v-model="showRemarkModal" title="备注">
      <Form
        ref="remarkForm"
        :model="remarkForm"
        :rules="remarkRules"
        :label-width="120"
      >
        <FormItem label="订单备注" prop="logistics_code">
          <Input
            v-model="remarkForm.remark"
            type="textarea"
            placeholder="请输入备注"
            :rows="3"
            :maxlength="500"
          ></Input>
        </FormItem>
      </Form>
      <template v-slot:footer>
        <Button type="default" @click="showRemarkModal = false">取消</Button>
        <Button type="primary" @click="confirmRemark">确认</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { GroupOrderStatus, PayType, ShipStatus } from "@/utils/enums";
import ExportsModal from "@/components/ExportsModal";

export default {
  name: "order-course",
  components: {
    ExportsModal,
  },
  data() {
    return {
      exportType: 0,
      searchCondition: {
        order_type: "",
        order_status: "",
        pay_type: "",
        pay_status: "",
        created_start: "",
        created_end: "",
        shop_name: "",
        teacher_name: "",
        mobile: "",
        ship_status: "",
        updated_start: "",
        updated_end: "",
        order_mix_status: "",
        order_number: "",
        init() {
          this.order_status = "";
          this.pay_type = "";
          this.pay_status = "";
          this.created_start = "";
          this.created_end = "";
          this.shop_name = "";
          this.teacher_name = "";
          this.mobile = "";
          this.ship_status = "";
          this.updated_start = "";
          this.updated_end = "";
          this.order_mix_status = "";
          this.order_number = "";
        },
      },
      onlyRefund: false,
      payType: PayType.getOptions(),
      tableColumns: [],
      modal: {
        show: false,
        title: "",
        type: "",
        data: {},
        btnLabel: "",
        form: {},
        rules: {},
      },
      showExportModal: false,
      exportModalTitle: "",
      showTop: true,
      showOnlyRefund: true,
      exportsRouteName: "",
      deliveryRow: {},
      showDeliveryModal: false,
      deliveryForm: {
        logistics_name: "",
        logistics_code: "",
        logistics_fee: 0,
        remark: "",
      },
      deliveryRules: {},
      showRemarkModal: false,
      remarkForm: {
        remark: "",
      },
      remarkRules: {},
      giftType: {
        12: "关联图书",
        16: "关联模考",
        8: "关联练习",
      },
      shippers: [],
      refundOrderStatus: [
        { value: 6, label: "退款成功" },
        { value: 8, label: "退款失败" },
        { value: 9, label: "退款申请中" },
      ],
    };
  },
  created() {
    if (this.$route.query.mobile) {
      this.searchCondition.mobile = this.$route.query.mobile;
    }
    this.initData();
    if (this.$route.query.order_number) {
      this.searchCondition.order_number = this.$route.query.order_number;
    } else {
      this.searchCondition.order_number = "";
    }
  },
  watch: {
    $route() {
      this.initData();
      if (this.$route.query.order_number) {
        this.searchCondition.order_number = this.$route.query.order_number;
      } else {
        this.searchCondition.order_number = "";
      }
      this.$refs.grid.searchRefresh();
    },
  },
  methods: {
    onRefundTypeChange() {
      this.modal.form.remark = "";
      this.$nextTick(() => {
        this.$refs.modalForm.validateField("remark");
      });
    },
    onDateRange(range) {
      this.searchCondition.created_start = range[0];
      this.searchCondition.created_end = range[1];
    },
    onUpdateDateRange(range) {
      this.searchCondition.updated_start = range[0];
      this.searchCondition.updated_end = range[1];
    },
    onrowsFormatter(rows) {
      let typeName = this.$route.query.type || this.$route.name;
      rows.forEach((i) => {
        i.order_status_name = GroupOrderStatus.getValue(i.order_mix_status);
        i.ship_status_name = ShipStatus.getValue(i.ship_status);
        if (
          (typeName == "OrderExercise" && i.shop_type != 15) ||
          (typeName == "OrderExam" && i.shop_type != 16)
        ) {
          i.pay_type_name = "课程赠送";
        } else {
          i.pay_type_name = PayType.getValue(i.pay_type) || "-";
        }
        i.created_at = this.$pub.timestampToTime(i.created_at);
        i.order_price = this.$pub.calcPrice(i.order_price);
        i.refund_price = this.$pub.calcPrice(i.refund_price);
        if (this.$route.name == "OrderOne") {
          i.oto_duration = this.$pub.getDuration(i.oto_start_at, i.oto_end_at);
        }
        if (i.refund_refuse_time) {
          i.refund_refuse_time = this.$pub.timestampToTime(
            i.refund_refuse_time
          );
        }
      });
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      if (this.searchCondition.order_type != 8) {
        this.$refs.formDate.handleClear();
        this.$refs.formUpdateDate.handleClear();
      } else {
        this.searchCondition.pay_status = 3;
      }
      this.$refs.grid.searchRefresh();
    },
    onOnlyRefundChange(val) {
      this.searchCondition.pay_status = val ? 3 : "";
      this.$refs.grid.searchRefresh();
    },
    onExport() {
      this.showExportModal = true;
    },
    onWatch() {
      this.$router.push({
        name: this.exportsRouteName,
        query: {
          type: "order",
          order_type: this.searchCondition.order_type,
        },
      });
    },
    onDetail(row) {
      this.modal.show = true;
      this.modal.title = "订单详情";
      this.modal.type = "detail";
      this.modal.btnLabel = "关闭";
      this.$http.get("/api/order/" + row.order_item_id).then((data) => {
        data.created_at = this.$pub.timestampToTime(data.created_at);
        data.pay_type_name = PayType.getValue(data.pay_type) || "-";
        data.order_status_name = GroupOrderStatus.getValue(
          data.order_mix_status
        );
        data.original_price = this.$pub.calcPrice(data.original_price);
        data.coupon_discount = this.$pub.calcPrice(data.coupon_discount);
        data.order_price = this.$pub.calcPrice(data.order_price);
        data.ship_status_name = ShipStatus.getValue(data.ship_status);
        this.modal.data = data;
        console.log(this.modal.data);
      });
    },
    onShowRemarkModal(row) {
      this.showRemarkModal = true;
      this.remarkForm.remark = row.remark;
      this.remarkForm.id = row.order_item_id;
    },
    onChangePrice(row) {
      this.modal.show = true;
      this.modal.title = "订单改价";
      this.modal.type = "change";
      this.modal.btnLabel = "确定";
      this.modal.data = row;
      this.modal.form = {
        adjustment_price: +this.modal.data.order_price,
      };
      this.modal.rules = {
        adjustment_price: [{ required: true, message: "金额不能为空" }],
      };
    },
    onRefund(row) {
      this.modal.show = true;
      this.modal.title = "处理退款";
      this.modal.type = "refund";
      this.modal.btnLabel = "确定";
      this.modal.data = row;
      this.modal.form = {
        id: row.refund_id,
        refund_price: +row.order_price,
        type: "2",
        remark: "",
      };
      this.modal.rules = [{ required: true, message: "备注信息不能为空" }];
    },
    onModalOk() {
      switch (this.modal.type) {
        case "detail":
          this.modal.show = false;
          break;
        case "change":
          this.$refs.modalForm.validate((valid) => {
            if (!valid) return;
            this.$http
              .put(
                "/api/order/adjustment/" + this.modal.data.order_id,
                this.modal.form
              )
              .then((data) => {
                this.$Message.success("价格修改成功");
                this.modal.data.order_price = this.$pub.calcPrice(
                  data.adjustment_price
                );
                this.modal.show = false;
              });
          });
          break;
        case "refund":
          this.$refs.modalForm.validate((valid) => {
            if (!valid) return;
            this.$http
              .post("/api/refund/auditing", this.modal.form)
              .then((data) => {
                if (this.modal.form.type == 2) {
                  this.$Message.success("已拒绝退款");
                  this.$refs.grid.searchRefresh();
                } else if (data.res) {
                  this.$http
                    .post("/api/refund/doAudit", {
                      type: 1,
                      refund_price: this.modal.form.refund_price,
                      id: data.res,
                    })
                    .then(() => {
                      this.$Message.success("退款成功");
                      this.$refs.grid.searchRefresh();
                    });
                }
              });
            this.modal.show = false;
          });
          break;
      }
    },
    initData() {
      this.searchCondition.init();
      this.searchCondition.shop_name = this.$route.query.name || "";
      this.searchCondition.mobile = this.$route.query.mobile || "";
      this.exportsRouteName = "";
      this.onlyRefund = false;
      this.showOnlyRefund = true;
      this.showTop = true;
      this.tableColumns = [
        {
          title: "订单编号",
          key: "order_number",
          align: "center",
          minWidth: 200,
        },
        { title: "商品名称", key: "shop_name", align: "center", minWidth: 200 },
        {
          title: "订单金额",
          key: "order_price",
          align: "center",
          minWidth: 100,
        },
        {
          title: "订单状态",
          key: "order_status_name",
          align: "center",
          minWidth: 100,
        },
        {
          title: "支付类型",
          key: "pay_type_name",
          align: "center",
          minWidth: 100,
        },
        {
          title: "下单时间",
          key: "created_at",
          align: "center",
          minWidth: 150,
        },
        { title: "买家", key: "nickname", align: "center", minWidth: 120 },
        { title: "买家手机号", key: "mobile", align: "center", minWidth: 120 },
        {
          title: "QQ",
          key: "qq",
          align: "center",
          minWidth: 150,
        },
        {
          title: "微信",
          key: "weixin",
          align: "center",
          minWidth: 150,
        },
        {
          title: "推荐人",
          key: "referrer",
          align: "center",
          minWidth: 150,
        },

        { title: "备注", key: "remark", align: "center", minWidth: 120 },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200,
          fixed: "right",
        },
      ];
      let typeName = this.$route.query.type || this.$route.name;
      switch (typeName) {
        case "OrderCourse":
          this.searchCondition.order_type = 2;
          this.exportsRouteName = "OrderCourseExports";
          this.exportModalTitle = "导出课程订单";
          break;
        case "OrderExercise":
          this.exportsRouteName = "OrderCourseExports";
          this.searchCondition.order_type = 5;
          break;
        case "OrderExam":
          this.exportsRouteName = "OrderCourseExports";
          this.searchCondition.order_type = 6;
          break;
        case "OrderOne":
          this.searchCondition.order_type = 1;
          this.exportsRouteName = "OrderOneExports";
          this.exportModalTitle = "导出一对一订单";
          this.showOnlyRefund = false;
          this.tableColumns = [
            {
              title: "订单编号",
              key: "order_number",
              align: "center",
              minWidth: 200,
            },
            {
              title: "预约老师",
              key: "teachers",
              align: "center",
              minWidth: 200,
            },
            {
              title: "预约时段",
              key: "oto_duration",
              align: "center",
              minWidth: 200,
            },
            {
              title: "订单金额",
              key: "order_price",
              align: "center",
              minWidth: 100,
            },
            {
              title: "订单状态",
              key: "order_status_name",
              align: "center",
              minWidth: 100,
            },
            {
              title: "支付类型",
              key: "pay_type_name",
              align: "center",
              minWidth: 100,
            },
            {
              title: "下单时间",
              key: "created_at",
              align: "center",
              minWidth: 150,
            },
            { title: "买家", key: "nickname", align: "center", minWidth: 120 },
            {
              title: "买家手机号",
              key: "mobile",
              align: "center",
              minWidth: 120,
            },
            { title: "备注", key: "remark", align: "center", minWidth: 120 },
            {
              title: "操作",
              slot: "action",
              align: "center",
              minWidth: 200,
              fixed: "right",
            },
          ];
          break;
        case "OrderMember":
          this.searchCondition.order_type = 3;
          this.exportsRouteName = "OrderMemberExports";
          this.exportModalTitle = "导出会员订单";
          this.showOnlyRefund = false;
          break;
        case "OrderExercise":
          this.searchCondition.order_type = 5;
          break;
        case "OrderExam":
          this.searchCondition.order_type = 6;
          break;
        case "OrderRefund":
          this.searchCondition.order_type = 8;
          this.searchCondition.pay_status = 3;
          // this.showTop = false;
          this.showOnlyRefund = false;
          break;
        case "OrderBook":
          this.searchCondition.order_type = 4;
          this.exportsRouteName = "OrderBookExports";
          this.exportModalTitle = "导出图书订单";
          this.showOnlyRefund = true;
          this.tableColumns = [
            {
              title: "订单编号",
              key: "order_number",
              align: "center",
              minWidth: 200,
            },
            {
              title: "商品名称",
              key: "shop_name",
              align: "center",
              minWidth: 200,
            },
            {
              title: "订单金额",
              key: "order_price",
              align: "center",
              minWidth: 100,
            },
            {
              title: "订单状态",
              key: "order_status_name",
              align: "center",
              minWidth: 100,
            },
            {
              title: "支付类型",
              key: "pay_type_name",
              align: "center",
              minWidth: 100,
            },
            { title: "买家", key: "nickname", align: "center", minWidth: 120 },
            {
              title: "买家手机号",
              key: "mobile",
              align: "center",
              minWidth: 120,
            },
            {
              title: "下单时间",
              key: "created_at",
              align: "center",
              minWidth: 150,
            },
            {
              title: "更新时间",
              key: "created_at",
              align: "center",
              minWidth: 150,
            },
            { title: "备注", key: "remark", align: "center", minWidth: 120 },
            {
              title: "操作",
              slot: "action",
              align: "center",
              minWidth: 200,
              fixed: "right",
            },
          ];
          this.requestShipCompony();
          break;
      }
    },
    async onDelivery(row) {
      this.deliveryForm.logistics_name = "";
      this.deliveryForm.logistics_code = "";
      this.deliveryForm.logistics_fee = 0;
      this.deliveryForm.remark = "";
      this.deliveryRow = row;
      await this.$http.get("/api/order/" + row.order_item_id).then((data) => {
        this.deliveryRow = data;
      });
      this.showDeliveryModal = true;
    },
    async confirmDelivery() {
      await this.$http.post("/api/ship/createDelivery", {
        order_id: this.deliveryRow.order_item_id,
        logistics_name: this.deliveryForm.logistics_name,
        logistics_code: this.deliveryForm.logistics_code,
        logistics_fee: this.deliveryForm.logistics_fee,
        remark: this.deliveryForm.remark,
      });
      this.showDeliveryModal = false;
      this.$Message.success("发货成功");
      this.$refs.grid.refresh();
    },

    async confirmRemark(row) {
      await this.$http.post("/api/extra/order/setRemark", {
        id: this.remarkForm.id,
        remark: this.remarkForm.remark,
      });
      this.showRemarkModal = false;
      this.$Message.success("备注成功");
      this.$refs.grid.refresh();
    },

    onShip() {
      this.$router.push({ name: "OrderShipImports", query: { type: "ship" } });
    },

    requestShipCompony() {
      this.$http.get("/api/ship/shippers").then((res) => {
        this.shippers = res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-course {
  .table-btn-box {
    display: flex;
    flex-direction: column;
    .action-button {
      display: flex;
      flex-direction: row;
      .ivu-btn {
        padding: 0 3px;
      }
    }
  }
  .refunding {
    color: red !important;
  }
  .refund-success,
  .refund-fail {
    color: #ff5e30 !important;
    min-width: 50px;
  }
}
.modal .ivu-form-item {
  margin-bottom: 10px;
}
</style>
